import {
  ADD_LOOKUP,
  EDIT_LOOKUP,
  FETCH_LOOKUP,
  DELETE_LOOKUP,
  DESTROY_LOOKUP
} from "../actionTypes";
import { LOOKUP } from '../config/index';

const lookupReducer = (state = [], action) => {
  switch (action.type) {
    case FETCH_LOOKUP:
      state = [];
      return [...state, ...action.lookup];

    case ADD_LOOKUP:
      let currentState;
      if (LOOKUP.LIMIT === state.length) {
        state.pop();
        currentState = state;
      } else {
        currentState = state;
      }
      return [action.lookup, ...currentState];

    case DELETE_LOOKUP:
      return state.filter(({ id }) => id !== action.id);

    case EDIT_LOOKUP:
      return state.map(row => {
        if (row.id === action.lookup.id) {
          return {
            ...row,
            ...action.lookup
          };
        }
        return row;
      });

    case DESTROY_LOOKUP:
      return state[action.key] = [];

    default:
      return state;
  }
};

export default lookupReducer;
